import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageSquare, X } from 'lucide-react';

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  // Don't show on contact page
  const isContactPage = location.pathname === '/contact';

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 400px
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isContactPage || !isVisible) return null;

  return (
    <div className="fixed bottom-24 right-6 z-[9998] flex flex-col items-end gap-3" data-testid="floating-cta">
      {/* Expanded options */}
      {isExpanded && (
        <div className="flex flex-col gap-3 animate-fade-in-up">
          <a
            href="tel:403-402-6596"
            className="flex items-center gap-3 bg-white text-[#0f172a] px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all font-medium text-sm"
            data-testid="floating-call-btn"
          >
            <Phone size={18} className="text-[#c5a059]" />
            Call Now
          </a>
          <Link
            to="/contact"
            className="flex items-center gap-3 bg-white text-[#0f172a] px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all font-medium text-sm"
            data-testid="floating-contact-btn"
          >
            <MessageSquare size={18} className="text-[#c5a059]" />
            Free Estimate
          </Link>
        </div>
      )}

      {/* Main toggle button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all ${
          isExpanded 
            ? 'bg-[#0f172a] text-white rotate-45' 
            : 'bg-[#c5a059] text-[#0f172a] hover:bg-[#0f172a] hover:text-white'
        }`}
        aria-label={isExpanded ? 'Close menu' : 'Get in touch'}
        data-testid="floating-toggle-btn"
      >
        {isExpanded ? <X size={24} /> : <MessageSquare size={24} />}
      </button>
    </div>
  );
};

export default FloatingCTA;
